import { checkboxAnatomy, switchAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, StyleFunctionProps } from '@chakra-ui/react';

export function createColorModePicker(colorMode: StyleFunctionProps['colorMode']) {
  return <T>(light: T, dark: T): T => (colorMode === 'light' ? light : dark);
}

export const checkboxHelpers = createMultiStyleConfigHelpers(checkboxAnatomy.keys);
export const switchHelpers = createMultiStyleConfigHelpers(switchAnatomy.keys);
